import React from 'react';
import { AccessPage } from './components/AccessPage';

export function MainView(): React.JSX.Element {
  return (
    <div className="checkaccess-react-portlet">
      <AccessPage />
    </div>
  );
}
